import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=16547f16&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=16547f16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16547f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16547f16')) {
      api.createRecord('16547f16', component.options)
    } else {
      api.reload('16547f16', component.options)
    }
    module.hot.accept("./ImageUpload.vue?vue&type=template&id=16547f16&scoped=true", function () {
      api.rerender('16547f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ImageUpload.vue"
export default component.exports